import {Injectable} from '@angular/core';
// eslint-disable-next-line n/no-extraneous-import
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GenericCrudService} from '@gatewee/services/generic-crud.service';
import {PaymentMethodsSettings} from '@gatewee/types/domain-setting';
import {Recipient} from '@gatewee/types/recipient';
import {RecipientLimitsSnapshot} from '@gatewee/types/recipient-setting';

@Injectable({
  providedIn: 'root',
})
export class RecipientsSettingsService extends GenericCrudService<Recipient> {
  constructor(public override http: HttpClient) {
    super('/recipients-settings/recipient', http);
  }

  findPaymentMethods(): Observable<PaymentMethodsSettings> {
    return this.http
      .get<PaymentMethodsSettings>(this.baseUrl + '/payment-methods')
      .pipe();
  }

  findMaxInstallments() {
    return this.http
      .get<{
        maxInstallments: number;
      }>(this.baseUrl + '/credit-cards/max-installments')
      .pipe();
  }

  findSplitWhiteList(id: number) {
    return this.http
      .get<Recipient[]>(this.baseUrl + '/split-whitelist/' + id)
      .pipe();
  }

  getAllSplitWhiteList() {
    return this.http.get<Recipient[]>(this.baseUrl + '/split-whitelist').pipe();
  }

  findLimits(): Observable<RecipientLimitsSnapshot> {
    return this.http.get<RecipientLimitsSnapshot>(`${this.baseUrl}/limits`);
  }
}
